import React from "react";

import {
  Menu,
  Bell,
  ChevronDown
} from "lucide-react";

const Header = ({
  user = null,
  onMenuClick,
  onProfileClick
}) => {
  const userName = user?.name || "User";

  const userInitial =
    userName.charAt(0).toUpperCase();

  const primaryRole =
    user?.roles?.[0] || "USER";

  return (
    <header className="dashboard-header">
      <div className="header-left">
        <button
          type="button"
          className="header-menu-button"
          onClick={onMenuClick}
          aria-label="Open menu"
        >
          <Menu size={22} />
        </button>

        <div className="header-page-info">
          <span className="header-welcome">
            Welcome back
          </span>

          <strong>{userName}</strong>
        </div>
      </div>

      <div className="header-right">
        <button
          type="button"
          className="header-icon-button"
          aria-label="Notifications"
        >
          <Bell size={20} />

          <span className="notification-dot" />
        </button>

        <button
          type="button"
          className="header-profile"
          onClick={onProfileClick}
        >
          <div className="header-avatar">
            {userInitial}
          </div>

          <div className="header-user-info">
            <strong>{userName}</strong>
            <span>{primaryRole}</span>
          </div>

          <ChevronDown size={16} />
        </button>
      </div>
    </header>
  );
};

export default Header;